import { jsx } from "react/jsx-runtime";
import { TextInputFieldWUT } from "../../../ui/text-input-field/text-input-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const TextInputWUT = (props) => {
  const fieldType = FIELD_TYPES.TEXT_INPUT;
  return /* @__PURE__ */ jsx(TextInputFieldWUT, { ...props, fieldType });
};
export {
  TextInputWUT
};
//# sourceMappingURL=text-input-wut.js.map
